module.exports = __webpack_public_path__ + "assets/img/hintBg.671e91a6.png";